// extracted by mini-css-extract-plugin
module.exports = {"item":"item--QvTz8","textWrap":"textWrap--3IOHK","describe":"describe--2GzzJ","subDescribe":"subDescribe--2XfSg","imageWrap":"imageWrap--3sRrn"};